import {
  aquamarine180,
  blueViolet55,
  blueVioletDesat55,
  brownYellow155,
  fluorescentBlueViolet69,
  fluorescentPink119,
  fluorescentYellow194,
  gray7,
  pinkDesat25,
  redDesat155,
  redOrange155,
  violet75,
} from '@spotify-internal/encore-web/core';
import { black, white } from 'styles/colors';
import { VOICE_IDS } from '../ai-voice-section/constants';

type AudioScriptPlaybackCardColors = {
  background: string;
  text: string;
  playButton: string;
  playButtonText: string;
  highlightText: string;
};

export const AUDIO_SCRIPT_PLAYBACK_CARD_COLORS: Record<
  string,
  AudioScriptPlaybackCardColors
> = {
  [VOICE_IDS.RACHEL]: {
    background: blueViolet55,
    text: white,
    playButton: fluorescentPink119,
    playButtonText: white,
    highlightText: aquamarine180,
  },
  [VOICE_IDS.ADDISON]: {
    background: brownYellow155,
    text: gray7,
    playButton: blueVioletDesat55,
    playButtonText: white,
    highlightText: blueVioletDesat55,
  },
  [VOICE_IDS.DEREK]: {
    background: violet75,
    text: white,
    playButton: fluorescentYellow194,
    playButtonText: gray7,
    highlightText: redOrange155,
  },
  [VOICE_IDS.CHARLIE]: {
    background: redDesat155,
    text: pinkDesat25,
    playButton: black,
    playButtonText: white,
    highlightText: fluorescentBlueViolet69,
  },
};
